import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  standalone: false
})
export class ProfileComponent implements OnInit {
  user = '';
  userRoles: string[] = [];
  userProfile: any;

  constructor(
    private readonly router: Router,
    private readonly keycloakService: KeycloakUtilisateurService,
    private readonly authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.user = this.keycloakService.userProfile?.username ?? '';
    this.userRoles = this.keycloakService.allRoles;
    this.userProfile = this.keycloakService.userProfile;
  }

  manageKeycloakUsers(): void {
    this.router.navigate(['/users']);  // Use correct route
  }

  logout(): void {
    this.authService.logout();
  }
}
